export default __webpack_public_path__ + "static/star-7b2e60ebe0e025edeb8e4111adad6e7b.png";